// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";

export const isAiAgentGeminiInteractionsAppGroupIdResult = objectOf({});
